function hasFocusVisible(element: HTMLElement) {
  // Check if the element is the currently active/focused element
  const isFocused = document.activeElement === element;

  // Check if the element also matches the :focus-visible pseudo-class
  const isFocusVisible = element.matches(":focus-visible");

  // Both conditions must be true for the element to have visible focus
  return isFocused && isFocusVisible;
}

export { hasFocusVisible };
